import { FancyRadio } from 'apps/builder/components/settings/modal'
import { SettingsFieldSelect } from 'apps/builder/components/settings/modal/shared'
import { useDispatch } from 'react-redux'
import { updateEntry } from 'apps/builder/store/actions/entries'
import { RequiredToggle } from 'apps/builder/components/settings/modal/shared'

export const MultiChoiceField = ({
  guid,
  label,
  required,
  default: defaultValue = 'GC_BLANK_DEFAULT',
  style = 1,
  type,
  keyField,
}) => {
  const dispatch = useDispatch()

  return (
    <>
      <div className="settings--row">
        <SettingsFieldSelect
          guid={guid}
          label={label}
          keyField={keyField}
          type={type}
        />

        <div className="toggles-group">
          <div className="toggle-wrapper">
            <RequiredToggle guid={guid} active={required} />
          </div>
        </div>
      </div>

      <div className="settings--format--wrapper">
        <label className="settings--label">Style</label>
        <FancyRadio
          id={`${guid}-1`}
          label={'Checkboxes'}
          selected={style}
          value={2}
          onChange={(checked, value) => {
            checked
              ? (() => {
                  dispatch(
                    updateEntry({
                      guid,
                      style: value,
                      default: defaultValue,
                    })
                  )
                })()
              : ''
          }}
        />
        <FancyRadio
          id={`${guid}-2`}
          label={'Buttons'}
          selected={style}
          value={6}
          onChange={(checked, value) => {
            checked
              ? (() => {
                  dispatch(
                    updateEntry({
                      guid,
                      style: value,
                      default: defaultValue,
                    })
                  )
                })()
              : ''
          }}
        />
      </div>
    </>
  )
}
